export const FETCH_DSR_LOGS_EHS_ISSUES = '@@material/dsr-log-ehs-issues';
export const FETCH_DSR_LOGS_EHS_ISSUES_SUCCESS = '@@material/dsr-log-ehs-issues-success';
export const FETCH_DSR_LOGS_EHS_ISSUES_FAILURE = '@@material/dsr-log-ehs-issues-failure';
